import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AurChipConfig} from '../../components/common/aur-chip/AurChipList';
import {SingleClientTabStatus} from '../../components/pages/user-management/models';

type ProjectOverviewState = {
  filterState: AurChipConfig[] | null;
  selectedClientId: string | null;
  selectedProjectId: string | null;
  selectedWorkspaceId: string | null;
  tabLabel: SingleClientTabStatus;
  currentPage: number;
  itemsPerPage: number;
  startScroll: boolean;
};

const initialState: ProjectOverviewState = {
  filterState: null,
  selectedProjectId: null,
  selectedWorkspaceId: null,
  selectedClientId: null,
  tabLabel: SingleClientTabStatus.all,
  currentPage: 0,
  itemsPerPage: 0,
  startScroll: false,
};

const projectOverviewSlice = createSlice({
  name: 'projectOverViewSlice',
  initialState: initialState,
  reducers: {
    setFilterState: (state, action: PayloadAction<AurChipConfig[] | null>) => {
      state.filterState = action.payload;
    },
    setTabLabelState: (state, action: PayloadAction<SingleClientTabStatus>) => {
      state.tabLabel = action.payload;
    },
    setCurrentPageState: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setItemsPerPageState: (state, action: PayloadAction<number>) => {
      state.itemsPerPage = action.payload;
    },
    setSelectedProjectId: (state, action: PayloadAction<string | null>) => {
      state.selectedProjectId = action.payload;
    },
    setSelectedWorkspaceId: (state, action: PayloadAction<string | null>) => {
      state.selectedWorkspaceId = action.payload;
    },
    setStartScroll: (state, action: PayloadAction<boolean>) => {
      state.startScroll = action.payload;
    },
    setSelectedClientIdState: (state, action: PayloadAction<string | null>) => {
      state.selectedClientId = action.payload;
    },
    resetProjectOverviewState: () => ({...initialState}),
  },
});

export const {
  setFilterState,
  setItemsPerPageState,
  setCurrentPageState,
  setTabLabelState,
  setSelectedProjectId,
  setSelectedWorkspaceId,
  setStartScroll,
  setSelectedClientIdState,
  resetProjectOverviewState,
} = projectOverviewSlice.actions;
export default projectOverviewSlice.reducer;
